import { Injectable } from '@angular/core';
import { Option } from 'src/app/settings/model/value-field';

/**
 * Udostępnia zestawy unikalnych wartości kolumn (ValueField.filterOptionsFromData) poza tabelą -
 * korzysta z nich filtr z panelu bocznego, żeby zamiast wpisywania wartości z palca dać wybór z
 * listy.
 *
 * Rejestruje się tylko tabela mająca całość danych w pamięci (allDataPreloaded, czyli tryb
 * dzienny): przy danych stronicowanych lista pochodziłaby z jednej strony, a filtr z panelu idzie
 * na serwer po całość - podpowiadanie wartości z wycinka byłoby mylące.
 *
 * Widoczna tabela jest jedna, więc trzymamy jednego dostawcę; wyrejestrowanie sprawdza tożsamość,
 * żeby znikająca tabela nie zabrała listy tej, która weszła po niej.
 */
@Injectable({ providedIn: 'root' })
export class ColumnValuesProvider {

  private provider: ((columnName: string) => Option[]) | null = null;

  register(provider: (columnName: string) => Option[]): void {
    this.provider = provider;
  }

  unregister(provider: (columnName: string) => Option[]): void {
    if (this.provider === provider) this.provider = null;
  }

  getValues(columnName: string): Option[] {
    return this.provider?.(columnName) ?? [];
  }
}
